import { Info } from '@1debit/icons';
import { cn } from 'utils/styles';
import { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  invalid?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ label, error, invalid, ...restProps }, ref) => {
  return (
    <div className="flex flex-col w-full">
      {invalid && (
        <div className="font-sans text-sm font-medium flex align-center gap-2 relative pb-2">
          <Info className="inline" size={20} />
          {error}
        </div>
      )}
      <input
        ref={ref}
        aria-label={label}
        placeholder={label}
        className={cn(
          'font-sans label-saans font-medium px-[15px] py-2 w-full border text-kale placeholder-kale border-gray-300 rounded-md',
          'focus:border-kale flex-none leading-tight ',
          invalid && 'border-alert-500',
        )}
        {...restProps}
      />
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
